import angular from 'angular';

'use strict';

/**
 * @ngdoc overview
 * @name commonModule.treeModule
 * @description
 * # commonModule.treeModule
 * Module for managing the directives and services for tree views.
 */
const treeModule = angular.module('commonModule.treeModule', []);

/**
 * @ngdoc directive
 * @name commonModule.treeModule.directive:placesTree
 * @description
 * Directive for tree view of Places (places permissions)
 */
treeModule.directive('checkboxPlacesTree', () => {
    return {
        template: '<ul class="place-tree"><checkbox-row ng-repeat="place in places" class="place"></checkbox-row></ul>',
        replace: true,
        transclude: true,
        restrict: 'AE',
        scope: {
            places: '=ngModel',
            selected: '=selectedPlaces',
            affectParents: '=',   // Should toggle selected affect all ancestors of the node? (used in segments, in reports)
            readWrite: '='
        },
        controller: ['$scope', ($scope) => {
            if (!$scope.readWrite) {
                const getSelectedArray = (type) => {
                    let array;

                    if (angular.isDefined($scope.selected[type + 's'])) {
                        array = $scope.selected[type + 's'];
                    } else {
                        throw new Error('No such TYPE in selected array!');
                    }

                    return array;
                };

                const checkPlaces = (places) => {
                    angular.forEach(places, (place) => {
                        const array = getSelectedArray(place.type);

                        if (angular.isDefined(array)) {
                            const index = array.indexOf(place.id);
                            place.selected = (index >= 0);
                        }
                    });
                };

                const deselectNode = (node) => {
                    const array = getSelectedArray(node.type),
                        indexOf = array.indexOf(node.id);

                    if (indexOf >= 0) {
                        array.splice(indexOf, 1);
                    }
                    node.selected = false;
                };

                const selectNode = (node) => {
                    const array = getSelectedArray(node.type),
                        indexOf = array.indexOf(node.id);

                    if (indexOf < 0) {
                        array.push(node.id);
                    }
                    node.selected = true;
                };

                const deselectChildren = (nodes) => {
                    if (angular.isDefined(nodes) && nodes.length) {
                        angular.forEach(nodes, (node) => {
                            deselectNode(node);
                            deselectChildren(node.children);
                        });
                    }
                };

                const selectChildren = (nodes) => {
                    if (angular.isDefined(nodes) && nodes.length) {
                        angular.forEach(nodes, (node) => {
                            selectNode(node);
                            selectChildren(node.children);
                        });
                    }
                };

                // Count selected children in an array
                const countSelectedChildren = (children) => {
                    let count = 0;
                    if (angular.isDefined(children)) {
                        angular.forEach(children, (child) => {
                            if (child.selected) {
                                count += 1;
                            }
                        });
                    }
                    return count;
                };

                // Check all ancestors of the node (place), if they should be (de)selected as well
                const checkParents = (place, $event) => {
                    let currentScope = angular.element($event.target).scope();
                    currentScope = currentScope.$parent;

                    while (angular.isDefined(currentScope.$parent) &&
                    (angular.isDefined(currentScope.place) || angular.isDefined(currentScope.places))) {

                        if (angular.isDefined(currentScope.place) &&
                            !(currentScope.place.id === place.id && currentScope.place.type === place.type)) {

                            const children = currentScope.place.children;

                            if (angular.isDefined(children)) {
                                // Check if all children are selected
                                const selectedCount = countSelectedChildren(children);

                                // If so, select parent as well
                                if (selectedCount === children.length) {
                                    selectNode(currentScope.place);
                                } else {
                                    deselectNode(currentScope.place);
                                }
                            }

                            if (!place.selected) {
                                deselectNode(currentScope.place);
                            }
                        }
                        currentScope = currentScope.$parent;
                    }
                };

                $scope.$watchGroup(['places', 'selected'], function (newValues) {
                    const places = newValues[0],
                        selected = newValues[1];

                    if (angular.isDefined(places) && angular.isDefined(selected)) {
                        checkPlaces($scope.places);
                    }
                });

                $scope.toggleSelected = function (place, $event) {
                    const array = getSelectedArray(place.type);

                    if (angular.isDefined(array)) {
                        if (place.selected) {
                            selectNode(place);
                            selectChildren(place.children);
                        } else {
                            deselectNode(place);
                            if ($scope.affectParents) {
                                deselectChildren(place.children);
                            }
                        }
                        if ($scope.affectParents) {
                            checkParents(place, $event);
                        }
                    }
                };
            }
        }]
    };
});

/**
 * @ngdoc directive
 * @name commonModule.treeModule.directive:checkboxRow
 * @description
 * Directive for tree row with checkbox
 */
treeModule.directive('checkboxRow', ['$compile', ($compile) => {
    return {
        restrict: 'E',
        templateUrl: 'views/common/tree/checkboxTreeRow.tpl.html',
        link: (scope, elm) => {
            if (angular.isDefined(scope.place.children) && scope.place.children.length > 0) {
                const childChoice = $compile('<checkbox-places-tree ng-model="place.children" ng-show="place.showChildren" selected-places="selected" affect-parents="affectParents" read-write="readWrite"></checkbox-places-tree>')(scope);
                elm.append(childChoice);
            }
        },
        controller: ['$scope', 'TreeService', ($scope, TreeService) => {
            $scope.toggleChildren = (place) => {
                place.showChildren = !place.showChildren;
            };

            if ($scope.affectParents) {
                $scope.$watch('place.children', () => {
                    // Count selected or indeterminate children
                    const countSelectedOrIndeterminate = (children) => {
                        let count = 0;
                        if (angular.isDefined(children)) {
                            angular.forEach(children, (child) => {
                                if (child.selected || child.indeterminate) {
                                    count += 1;
                                }
                            });
                        }
                        return count;
                    };

                    const selectedCount = countSelectedOrIndeterminate($scope.place.children);
                    $scope.place.indeterminate = (selectedCount > 0);
                }, true);
            }

            $scope.getIconToggleClass = TreeService.getIconToggleClass;
            $scope.getIconClass = TreeService.getIconClass;
            $scope.getPlaceTooltip = TreeService.getPlaceTooltip;
        }]
    };
}]);

/**
 * @ngdoc directive
 * @name commonModule.treeModule.directive:readWriteTree
 * @description
 * Directive for tree view of Places with read and write checkboxes (client page - places permissions)
 */
treeModule.directive('readWriteTree', ['TreeManager', (TreeManager) => {
    return {
        restrict: 'AE',
        scope: {
            selected: '=placesSelected'
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$timeout', 'Client', ($scope, $timeout, Client) => {
            const ctrl = this;

            ctrl.toggleRead = (node) => {
                TreeManager.toggleNode(node, 'read');
            };

            ctrl.toggleWrite = (node) => {
                TreeManager.toggleNode(node, 'write');
            };

            $scope.getPlaces = (params, callback) => {
                $scope.isLoading = true;
                Client.getPlaces(params)
                    .then((result) => {
                        let data = result.data;

                        const places = data.places;
                        $scope.places = places.data;
                        $scope.numPages = places.lastPage;
                        $scope.numItems = places.total;
                        $scope.rangeFrom = places.from;
                        $scope.rangeTo = places.to;
                        $scope.perPage = places.perPage;
                        $scope.page = places.currentPage - 1;
                        callback();
                    })
                    .finally(() => {
                        $scope.isLoading = false;
                    });
            };

            $scope.filterText = '';
            let tempFilterText = '';
            let filterTextTimeout;

            $scope.$watch('search.query', (val) => {
                if (filterTextTimeout) {
                    $timeout.cancel(filterTextTimeout);
                }

                tempFilterText = val;
                filterTextTimeout = $timeout(() => {
                    $scope.filterText = tempFilterText;
                    if (angular.isDefined($scope.filterText)) {
                        $scope.getPlaces({name: $scope.filterText}, () => {
                            TreeManager.initSelect($scope.places, $scope.selected);
                        });
                    }
                }, 500); // delay 500 ms
            });

            $scope.$watch('selected', function (val) {
                if (angular.isDefined(val)) {
                    $scope.getPlaces({}, function () {
                        TreeManager.initSelect($scope.places, $scope.selected);
                    });
                }
            });
        }],
        templateUrl: 'views/common/tree/readWriteTree.tpl.html'
    };
}]);

/**
 * @ngdoc directive
 * @name commonModule.treeModule.directive:readWriteTreeCheckbox
 * @description
 * Directive for places tree row with read-write checkbox
 */
treeModule.directive('readWriteTreeCheckbox', () => {
    return {
        scope: {
            node: '=readWriteTreeCheckbox'
        },
        require: '^readWriteTree',
        link: (scope, element, attr, ctrl) => {
            scope.ctrl = ctrl;
        },
        template: '<div ng-model="node.selected" btn-class="btn-link" read-change="ctrl.toggleRead(node)" write-change="ctrl.toggleWrite(node)" read-write-tree-btn></div>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.treeModule.directive:readWriteTreeBtn
 * @description
 * Directive for Read & Write Tree
 */
treeModule.directive('readWriteTreeBtn', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            data: '=ngModel',
            btnClass: '@',
            readChange: '&',
            writeChange: '&'
        },
        templateUrl: 'views/common/tree/readWriteTreeBtn.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.treeModule.directive:placesTreePagination
 * @description
 * Directive for Places tree pagination (server-side)
 */
treeModule.directive('placesTreePagination', ['TreeManager', (TreeManager) => {
    return {
        restrict: 'AE',
        scope: false,
        templateUrl: 'views/common/tree/pagination.tpl.html',
        controller: ['$scope', ($scope) => {
            $scope.linkGroupSize = 3;

            $scope.gotoPage = (i) => {
                $scope.page = i;
            };

            $scope.linkGroupFirst = () => {
                const rightDebt = Math.max(0,
                    $scope.linkGroupSize - ($scope.numPages - 1 - ($scope.page + 2))
                );

                return Math.max(0,
                    $scope.page - ($scope.linkGroupSize + rightDebt)
                );
            };

            $scope.linkGroupLast = () => {
                const leftDebt = Math.max(0,
                    $scope.linkGroupSize - ($scope.page - 2)
                );

                return Math.min($scope.numPages - 1,
                    $scope.page + ($scope.linkGroupSize + leftDebt)
                );
            };

            $scope.$watch('page', (newPage, oldPage) => {
                if (newPage !== oldPage) {
                    if (newPage < 0 || newPage + 1 > $scope.numPages) {
                        $scope.page = oldPage;

                        return;
                    } else if (oldPage >= 0 && oldPage + 1 <= $scope.numPages) {
                        $scope.getPlaces({
                            page: newPage + 1
                        }, () => {
                            TreeManager.initSelect($scope.places, $scope.selected);
                        });
                    }
                }
            });
        }]
    };
}]);

/**
 * @ngdoc interface
 * @name commonModule.treeModule.interface:TreeManager
 * @description
 * Service for handling the tree view for places permissions.
 */
treeModule.factory('TreeManager', ['AppsoupAPI', (AppsoupAPI) => {
    let selected;

    // Forward declarations to avoid hoisting issues
    let selectInArray, selectChildren;

    const getSelectedArray = (type) => {
        const array = selected[type + 's'];
        if (angular.isDefined(array)) {
            return array;
        } else {
            throw new Error('No such TYPE in places tree.');
        }
    };

    const indexOfPlace = (place) => {
        let index = -1;

        angular.forEach(getSelectedArray(place.type), (data, _index) => {
            if (parseInt(place.id) === parseInt(data.id)) {
                index = _index;
            }
        });

        return index;
    };

    const selectNode = (node, mode) => {
        node.selected[mode] = true;
        selectInArray(node);
        selectChildren(node.children, mode);
    };

    selectChildren = (children, mode) => {
        if (angular.isDefined(mode)) {
            if (angular.isDefined(children)) {
                angular.forEach(children, (child) => {
                    if (angular.isNullOrUndefined(child.selected)) {
                        child.selected = {};
                    }
                    child.selected[mode] = true;
                    selectNode(child, mode);
                });
            }
        } else {
            throw new Error('"Mode" in selectChildren function is not defined!');
        }
    };

    selectInArray = (node) => {
        if (angular.isDefined(node)) {
            const index = indexOfPlace(node),
                array = getSelectedArray(node.type);

            if (index >= 0) { // Already in array
                array[index].m = AppsoupAPI.calculateMode(node.selected);
            } else {
                array.push({
                    id: node.id,
                    m: AppsoupAPI.calculateMode(node.selected)
                });
            }
        }
    };

    const deselectNode = (node, mode) => {
        const index = indexOfPlace(node),
            array = getSelectedArray(node.type),
            currentMode = array[index].m;
        let newMode;

        node.selected[mode] = false;

        if (mode === 'read') {
            newMode = currentMode - 1;
        } else if (mode === 'write') {
            newMode = currentMode - 2;
        }

        if (index >= 0) { // Make sure that node is in array
            if (newMode === 0) {
                array.splice(index, 1);
            } else {
                array[index].m = newMode;
            }
        }
    };

    const treeManager = {
        initSelect: (nodes, _selected) => {
            if (angular.isDefined(_selected)) {
                selected = _selected;
            }

            angular.forEach(nodes, (node) => {
                const index = indexOfPlace(node),
                    array = getSelectedArray(node.type);

                if (index >= 0) {
                    node.selected = AppsoupAPI.modeToObject(array[index].m);
                }

                if (angular.isDefined(node.children)) {
                    treeManager.initSelect(node.children);
                }
            });
        },
        toggleNode: (node, mode) => {
            if (angular.isDefined(node.selected) && angular.isDefined(node.selected[mode])) {
                if (!node.selected[mode]) {
                    selectNode(node, mode);
                } else {
                    deselectNode(node, mode);
                }
            } else {
                if (angular.isNullOrUndefined(node.selected)) {
                    node.selected = {};
                }
                selectNode(node, mode);
            }
        }
    };

    return treeManager;
}]);

export default treeModule.name;
